
        var result = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js!./delete-restore.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/delete-restore/delete-restore.scss
// module id = ofbY
// module chunks = 0